import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loader: false,
    token: false,
    contract: false,
  },
  mutations: {
    SET_LOADER(state, status) {
      state.loader = status;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_CONTRACT(state, contract) {
      state.contract = contract;
    },
  },
  actions: {
    setLoader({ commit }, status) {
      commit('SET_LOADER', status);
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', `Bearer ${token}`);
    },
    setContract({ commit }, contract) {
      commit('SET_CONTRACT', contract);
    },
  },
});
